<template>
  <div class="read-more">
    <div class="read-more__html" :style="styles" :class="classes">
      <slot />
    </div>
    <a v-if="showToggle" class="read-more__toggle" @click="toggleReadMore">
      {{ isExpanded ? toggleText.readLess : toggleText.readMore }}
    </a>
    <div v-if="!showToggle || isExpanded" class="read-more__expanded">
      <slot name="expanded" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductReadMore",
  props: {
    limit: {
      type: Number,
      default: 7,
    },
    isTruncated: {
      type: Boolean,
      default: false,
    },
    showToggle: {
      type: Boolean,
      default: false,
    },
    toggleText: {
      type: Object,
      default: () => ({
        readMore: "Read More",
        readLess: "Read Less",
      }),
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    styles() {
      if (this.isTruncated && !this.isExpanded) {
        return {
          lineClamp: this.limit,
          "-webkit-line-clamp": this.limit,
          "-webkit-box-orient": "vertical",
          overflow: "hidden",
          display: "-webkit-box",
        };
      }

      return null;
    },
    classes() {
      return {
        "--expanded": this.isExpanded || !this.isTruncated,
      };
    },
  },
  methods: {
    toggleReadMore() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.--expanded {
  line-clamp: unset;
  -webkit-line-clamp: unset;
  -webkit-box-orient: unset;
  overflow: unset;
  display: block;
}

.read-more {
  &__toggle {
    display: inline-block;
    margin-bottom: 24px;
    text-decoration: underline;
    cursor: pointer;
  }

  &__html {
    margin-bottom: 24px;
  }

  &__html + &__toggle {
    margin-top: -16px;
  }

  &__expanded:empty {
    display: none;
  }
}
</style>
